import React from 'react';

// Shared site footer, rendered on every page from App.tsx.
const HEADING_CLASS =
    'ods-text--size-india ods-text--size-hotel-breakpoint-medium ods-text--size-golf-breakpoint-large ods-text--weight-medium ods-margin-bottom-4';

const CONTACT_EMAIL = 'kontakt@annaipoopathi.no';
const COMPANY_NAME = 'Annaipoopathi aktivitets- og kultursenter (APTAK)';
const ORG_NUMBER = '937 718 659';
const POSTAL_ADDRESS = 'Liaveien 6B, 1476 Rasta';

const Footer: React.FC = () => (
    <footer className="ods-footer ods-margin-top-19">
        <div className="ods-footer__gutter">
            <div className="ods-footer__content">
                <div className="ods-grid ods-grid--gap">

                    <div className="ods-grid__column--6">
                        <h2 className={HEADING_CLASS}>Påmelding</h2>
                        <ul className="ods-unordered-list ods-unordered-list--clean">
                            <li className="ods-unordered-list__item">
                                <a href="/athleticsregistration" className="ods-link ods-link--state-light">Idrettsregistrering</a>
                            </li>
                            <li className="ods-unordered-list__item">
                                <a href="/examregistration" className="ods-link ods-link--state-light">Eksamensregistrering</a>
                            </li>
                            <li className="ods-unordered-list__item">
                                <a href="/medlemskontingent" className="ods-link ods-link--state-light">Medlemskontingent</a>
                            </li>
                        </ul>
                    </div>

                    <div className="ods-grid__column--6">
                        <h2 className={HEADING_CLASS}>Min side</h2>
                        <ul className="ods-unordered-list ods-unordered-list--clean">
                            <li className="ods-unordered-list__item">
                                <a href="/" className="ods-link ods-link--state-light">Forside</a>
                            </li>
                            <li className="ods-unordered-list__item">
                                <a href="/login" className="ods-link ods-link--state-light">Logg inn</a>
                            </li>
                            <li className="ods-unordered-list__item">
                                <a href="/register" className="ods-link ods-link--state-light">Registrer deg</a>
                            </li>
                            <li className="ods-unordered-list__item">
                                <a href="/privacy" className="ods-link ods-link--state-light">Personvernvilkår</a>
                            </li>
                            <li className="ods-unordered-list__item">
                                <a href="/salgsvilkar" className="ods-link ods-link--state-light">Salgsvilkår</a>
                            </li>
                        </ul>
                    </div>

                    <div className="ods-grid__column--12">
                        <h2 className={HEADING_CLASS}>Kontakt</h2>
                        <ul className="ods-unordered-list ods-unordered-list--clean">
                            <li className="ods-unordered-list__item">{COMPANY_NAME}</li>
                            <li className="ods-unordered-list__item">{POSTAL_ADDRESS}</li>
                            <li className="ods-unordered-list__item">
                                <a href={`mailto:${CONTACT_EMAIL}`} className="ods-link ods-link--state-light">{CONTACT_EMAIL}</a>
                            </li>
                            <li className="ods-unordered-list__item">Org.nr.: {ORG_NUMBER}</li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    </footer>
);

export default Footer;
